import PropTypes from 'prop-types';
import IconButton from '../atom/IconButton';
import useComponentVisible from '../../../../utilities/hooks/useComponentVisible';
import dots from '../../../../assets/icons/ic_three_dots.svg';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/ic_eye.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/ic_pencil.svg'
// import { ReactComponent as CopyIcon } from '../../../../assets/icons/ic_copy.svg';
import { ReactComponent as TrashIcon } from '../../../../assets/icons/ic_trash.svg';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import ProfileImage from '../../common/ProfileImage';
import {DateFormatHelper} from "../../../../utilities/helpers/DateFormatHelper";

const ProviderDiscountItem = ({ item,onProviderCustomersClicked,onEditClicked,onDeleteClicked }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const dictionary = useDictionary();


    const onContextClicked = () => {
		setIsComponentVisible(!isComponentVisible);
	};

	return (
		<tr style={{ cursor: 'pointer' }} onClick={() => onProviderCustomersClicked(item)}>
			<td>
                <div className="booking-customer-container" style={{margin:0}}>
                    <ProfileImage name={item.name} photo={item?.avatar_url} size={{ width: 24, height: 24,fontSize: 11, lineHeight: 14 }}/>
                    <div className='provider-booking-customer-name truncate' title={item.name}>{item.name}</div>
                </div>
			</td>
			<td>
				<div className="provider-customers-number">{item.email ? item.email : '-'}</div>
			</td>
			<td>
				<div className="provider-customers-number">
                    {item.phone ? item.phone : '-'}
                </div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.total_bookings ? item.total_bookings : 0 }</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.total_reviews ? item.total_reviews : 0}</div>
			</td>
			<td>
                <div className="provider-customers-duration">
                    {item.last_activity ? DateFormatHelper.monthYearFormat(item.last_activity): '-'}
                </div>
			</td>
			<td>
                <div className="provider-customers-duration">
                    {DateFormatHelper.monthYearFormat(item.created_at)}
                </div>
			</td>
            <td>
				<div className="provider-customers-actions-wrapper d-flex-center">
					<IconButton onClickIcon={onContextClicked} activeState={isComponentVisible} styleObject={{width: '32px',height: '32px',borderRadius: '6px'}}>
						<img src={dots} />
					</IconButton>

					<div ref={ref} className="provider-customers-action-menus-container">
						{isComponentVisible ? (
							<>
                                <div className="provider-customers-actions-container">
                                    <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onProviderCustomersClicked(item)}}>
                                        <EyeIcon />
                                        <div>{dictionary.view}</div>
                                    </div>
                                    <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onEditClicked(item)}}>
                                        <EditIcon />
                                        <div>{dictionary.edit}</div>
                                    </div>
                                    <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onDeleteClicked(item)}}>
                                        <TrashIcon />
                                        <div>{dictionary.delete}</div>
                                    </div>
                                </div>
							</>
						) : null}
					</div>
				</div>
			</td>
		</tr>
	);
};

ProviderDiscountItem.propTypes = {
	item: PropTypes.object,
    onProviderCustomersClicked: PropTypes.func,
    onEditClicked: PropTypes.func,
    onDeleteClicked: PropTypes.func,
    columns: PropTypes.object
};

export default ProviderDiscountItem;